var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89229 5.81958L2.46812 0.404994C2.37903 0.315171 2.27304 0.243877 2.15626 0.195224C2.03948 0.14657 1.91422 0.121521 1.78771 0.121521C1.66119 0.121521 1.53594 0.14657 1.41915 0.195224C1.30237 0.243877 1.19638 0.315171 1.10729 0.404994C0.928799 0.58455 0.828613 0.827441 0.828613 1.08062C0.828613 1.3338 0.928799 1.57669 1.10729 1.75624L5.85104 6.54791L1.10729 11.2917C0.928799 11.4712 0.828613 11.7141 0.828613 11.9673C0.828613 12.2205 0.928799 12.4634 1.10729 12.6429C1.19605 12.7335 1.30189 12.8055 1.41869 12.8549C1.53548 12.9042 1.66091 12.9299 1.78771 12.9304C1.9145 12.9299 2.03993 12.9042 2.15673 12.8549C2.27352 12.8055 2.37937 12.7335 2.46812 12.6429L7.89229 7.22833C7.98956 7.13859 8.0672 7.02967 8.1203 6.90844C8.17339 6.78721 8.20081 6.6563 8.20081 6.52395C8.20081 6.39161 8.17339 6.26069 8.1203 6.13946C8.0672 6.01823 7.98956 5.90932 7.89229 5.81958V5.81958Z",
    fill: "#EDD0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarrow);
export default __webpack_public_path__ + "static/media/rarrow.b8d35656894c823130e3099d3bc4b2c7.svg";
export { ForwardRef as ReactComponent };